<template>
    <div>
      <ht-user-selector
    v-model="value"
    :validate="validate"
    :name="inputName"
    :placeholder="placeholder"
    :permission="permission"
    :single="single"
    :config="config"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    :demensions="demensions"
    :default-demension="defaultDemension"
    :orgs="orgs"
    :roles="roles"
    :load-org-tree="loadOrgTree"
    :append-to-body="appendToBody"
    @load="handleLoad"
    @valueChange="valueChange"
    @loadDemensions="loadDemensions"
    @changeDemension="changeDemension"
    @loadOrgUser="loadOrgUser"
    @loadRoleUser="loadRoleUser"
    select-label="fullname"
    quick-search-props="fullname,account"
  />
    </div>
</template>
<script>
import utils from "@/hotent-ui-util.js";
export default {
  name: "eip-user-selector",
  props: {
    validate: [String, Object],
    value: String,
    name: String,
    placeholder: String,
    permission: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orgPath:"",
      page:"",
      data: [],
      demensions: [],
      defaultDemension: "",
      orgs: [],
      roles: [],
      tableColumns: [
        { prop: "fullname", label: "名称", width: "60" },
        { prop: "account", label: "账号", width: "60"},
        { prop: "orgname", label:"主组织", width:"100",tipField:'pathname' },
        { prop: "postname", label: "岗位"}
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0,
        showTotal: true
      },
      inputName:this.inputName()
    };
  },
  mounted() {

  },
  methods: {
    inputName(){
      let labeldesc = "";
      if (this.$slots && this.$slots.labeldesc && this.$slots.labeldesc[0].children && this.$slots.labeldesc[0].children[0].text) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    handleLoad(param, cb) {
      if(!param.path_ && (this.orgPath && this.orgPath!="0")){
        param.path_ = this.orgPath;
        //切换每页显示条数时（第一次进来）
        if(param.pageBean){
          if(param.pageBean.page>1 && this.page){
            param.pageBean.page = this.page;
            this.page = "";
          }
        }
      }
      let queryFilter = param;

      if (param.path_) {
        if(param.pageBean){
          queryFilter.pageBean = {
            page: param.pageBean.page,
            pageSize: param.pageBean.pageSize,
            total: 0,
            showTotal: true
          };
        }else{
          queryFilter.pageBean = {
            page: 1,
            pageSize: 50,
            total: 0,
            showTotal: true
          };
        }

        if(param.path_){
          let query = {
            property: "path_",
            value: param.path_,
            group: "main",
            operation: "RIGHT_LIKE",
            relation: "AND"
          };
          if (!queryFilter.querys) {
            queryFilter.querys = [];
          }
          queryFilter.querys.push(query);
          }
      }
      if (param.role_id_) {
        queryFilter.pageBean = {
          page: 1,
          pageSize: 50,
          total: 0,
          showTotal: true
        };
        let query = {
          property: "role_id_",
          value: param.role_id_,
          group: "main",
          operation: "EQUAL",
          relation: "AND"
        };
        if (!queryFilter.querys) {
          queryFilter.querys = [];
        }
        queryFilter.querys.push(query);
      }
      let _this = this;
      this.$http
        .post("${uc}/api/user/v1/users/queryUserWithMainOrgPost", queryFilter)
        .then(rep => {
          let data = rep.data;
          _this.data = data.rows;
          _this.pagination.page = data.page;
          _this.pagination.pageSize = data.pageSize;
          _this.pagination.total = data.total;
        })
        .finally(() => {
          cb();
        });
    },
    valueChange(value) {
      this.$emit("input", value);
    },
    loadOrgTree(node, resolve) {
      if (node && node.data && node.data.isParent) {
        if (node.data.children) {
          resolve(node.data.children);
        } else {
          this.$http
            .post("${uc}/api/org/v1/orgs/getByParentAndDem", {
              demId: node.data.demId,
              parentId: node.data.id
            })
            .then(rep => {
              resolve(rep.data);
            })
            .catch(function(error) {});
        }
      } else {
        resolve([]);
      }
    },
    changeDemension(currentDemensionId) {
      // 维度改变 重新获取组织
      let _this = this;
      this.$http
        .post("${uc}/api/org/v1/orgs/getByParentAndDem", {
          demId: currentDemensionId
        })
        .then(rep => {
          _this.orgs = utils.tile2nest(rep.data);
        })
        .catch(function(error) {});
    },
    loadOrgUser(org) {
      this.orgPath = org.path;
      // 根据组织获取用户
      this.handleLoad({ path_: org.path }, () => {});
    },
    loadRoleUser(role) {
      // 根据角色获取用户
      this.handleLoad({ role_id_: role.id }, () => {});
    },
    loadDemensions() {
      if (this.demensions.length == 0) {
        let _this = this;
        this.$http
          .get("${uc}/api/demension/v1/dems/getAll")
          .then(rep => {
            let data = rep.data;
            _this.demensions = data;
            _this.defaultDemension = data[0].id;
          })
          .catch(function(error) {});

        this.$http
          .post("${uc}/api/role/v1/roles/getAll")
          .then(rep => {
            _this.roles = utils.tile2nest(rep.data);
          })
          .catch(function(error) {});
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .dialog-selector__wrapper .el-dialog .el-dialog__title{
    font-size: 12px;
    font-weight:bold;
} 
/deep/ .cell{
  text-align:left;
}
/deep/ .el-tree-node__label {
  font-size: 12px;
}
</style>